import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/story", label: "Story" },
  { to: "/schedule", label: "Schedule" },
  { to: "/travel", label: "Travel" },
  { to: "/transport", label: "Transport" },
  { to: "/faq", label: "FAQ" },
  { to: "/rsvp", label: "RSVP" },
];

export function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav className="fixed top-0 left-0 right-0 z-20">
      {/* Desktop */}
      <div className={`hidden md:flex justify-center gap-6 py-8 px-8 text-base text-muted-foreground transition-colors duration-300 ${scrolled ? "bg-background/90 shadow-sm backdrop-blur" : ""}`}>
        {navLinks.map(({ to, label }) => (
          <Link key={to} to={to} className={`hover:text-foreground transition-colors px-1 ${pathname === to ? "text-foreground underline underline-offset-8 decoration-1px" : ""}`}>
            {label}
          </Link>
        ))}
      </div>

      {/* Mobile */}
      <div className={`md:hidden transition-all duration-300 ${open ? "bg-background/75 backdrop-blur shadow-md" : ""}`}>
        <div className="flex justify-start py-4 px-6">
          <button
            onClick={() => setOpen(!open)}
            className="text-muted-foreground hover:text-foreground transition-colors"
            aria-label="Toggle menu"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="4" y1="12" x2="20" y2="12" className="transition-all duration-300" style={{ transformOrigin: "12px 12px", transform: open ? "rotate(45deg)" : "translateY(-4px)" }} />
              <line x1="4" y1="12" x2="20" y2="12" className="transition-all duration-300" style={{ transformOrigin: "12px 12px", transform: open ? "rotate(-45deg)" : "translateY(4px)" }} />
            </svg>
          </button>
        </div>
        <div
          className={`flex flex-col items-center gap-4 text-base text-muted-foreground overflow-hidden transition-all duration-300 ease-in-out ${
            open ? "max-h-96 py-4 opacity-100" : "max-h-0 py-0 opacity-0"
          }`}
        >
          {navLinks.map(({ to, label }, i) => (
            <Link
              key={to}
              to={to}
              className={`hover:text-foreground transition-colors ${pathname === to ? "text-foreground underline underline-offset-4 decoration-[0.5px]" : ""}`}
              style={{ transitionDelay: open ? `${i * 50}ms` : "0ms" }}
              onClick={() => setOpen(false)}
            >
              {label}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
}
